import { useAppSelector } from "../app";

export function useCanManageUser() {
  const { data } = useAppSelector((state) => state.userAccess);
  return (
    data.userAccess.manage_roles_and_access === "yes" ||
    data.userAccess.add_users_with_mirror_rights === "yes"
  );
}
